import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Switch, Route, Link} from 'react-router-dom';
import app from './firebase';
import FolderList from './FolderList';
import SingleFolder from './SingleFolder';
import {VscLoading} from 'react-icons/vsc';

function App() {
  const [sdsFolders, setSdsFolders] = useState([]);
  const [loading, setLoading] = useState(true);
  const getAllFolders = async () => {
    try {
      const allFolders = await app.storage.getFolders({structure: 'tree'});
      let folderKeyValues = [];
      allFolders.map((single) => {
        if (single.name === 'SDS') {
          folderKeyValues = single.children.map((childFolder) => {
            return {
              name: childFolder.name,
              value: childFolder.name,
            };
          });
        }
      });
      // console.log('single', folderKeyValues);
      folderKeyValues.sort((a, b) => (a.name > b.name ? 1 : -1));
      setLoading(false);
      setSdsFolders(folderKeyValues);
    } catch (error) {
      console.error(
        'Something went wrong while retrieving the folders. Details:',
        error
      );
    }
  };
  useEffect(() => {
    getAllFolders();
  }, []);
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/folder/:folderName">
            <SingleFolder />
          </Route>
          <Route path="/">
            {loading && (
              <div className="loading-wrapper">
                <VscLoading />
              </div>
            )}
            {sdsFolders.length > 0 && <FolderList folders={sdsFolders} />}
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
